module.exports = __webpack_public_path__ + "static/media/Group 19.cf235589.svg";